import { get } from 'lodash';
import { usePrescriptionStore } from '../../stores/prescriptionStore';
import SigningInIHRFlow from './SigningInIHRFlow';
import DialogCertificates from './DialogCertificates';

interface PrescriptionSigningFlowsProps {
  onSelectCertificate(value: string): void;
}
export default function PrescriptionSigningFlows({onSelectCertificate}: PrescriptionSigningFlowsProps) {
  const { prescriberConfiguration } = usePrescriptionStore();
  const signingInIHR = get(prescriberConfiguration, 'AssinarViaProntuario', false);

  if (signingInIHR) {
    return <SigningInIHRFlow />;
  }

  return <DialogCertificates onSelectCertificate={onSelectCertificate}/>;
}
